import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface SearchProps {
  className?: string
  defaultValue?: string
  onChange: (value: string) => void
  placeholder?: string
}

const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.95833 10.2917C8.35157 10.2917 10.2917 8.35157 10.2917 5.95833C10.2917 3.5651 8.35157 1.625 5.95833 1.625C3.5651 1.625 1.625 3.5651 1.625 5.95833C1.625 8.35157 3.5651 10.2917 5.95833 10.2917Z"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3748 11.375L9.01855 9.0188"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const Search = ({
  className,
  defaultValue = '',
  onChange,
  placeholder = 'Buscar',
}: SearchProps) => {
  return (
    <div className={cn('flex h-fit w-full items-center gap-2 border-b pb-1', className)}>
      <SearchIcon className="h-4 w-4 fill-none stroke-[#BDBDBD]" />
      <Input
        className="text-primary placeholder:text-primary h-fit rounded-none border-0 p-0 text-[14px] font-light shadow-none focus-visible:ring-0"
        defaultValue={defaultValue}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
      />
    </div>
  )
}

export { Search }
